import { render, staticRenderFns } from "./TitlePoint.vue?vue&type=template&id=6e419704&scoped=true&"
import script from "./TitlePoint.vue?vue&type=script&lang=js&"
export * from "./TitlePoint.vue?vue&type=script&lang=js&"
import style0 from "./TitlePoint.vue?vue&type=style&index=0&id=6e419704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e419704",
  null
  
)

export default component.exports